import Typography from '@ui/Typography'
import { HStack, VStack } from '@ui/layout/Stack'

import * as styles from './CallQualityFeedbackHeader.css'

type CallQualityFeedbackHeaderProps = {
  title?: React.ReactNode
  subtitle?: React.ReactNode
}

export default function CallQualityFeedbackHeader({
  title,
  subtitle,
}: CallQualityFeedbackHeaderProps) {
  return (
    <HStack alignItems="center" className={styles.root}>
      <VStack>
        {title ? (
          // @ts-expect-error Provide Typography with a component prop
          <Typography color="textPrimary" variant="caption1">
            {title}
          </Typography>
        ) : null}
        {subtitle ? (
          // @ts-expect-error Provide Typography with a component prop
          <Typography color="textSecondary" variant="caption1">
            {subtitle}
          </Typography>
        ) : null}
      </VStack>
    </HStack>
  )
}
